import React from 'react'
import Status from './Status'

export * from './Status'
export default React.memo(Status)
